// extracted by mini-css-extract-plugin
export default {"wrapper":"ForgotPassword_wrapper__y+ApW","container":"ForgotPassword_container__qREvc"};